import type { RouteRecordRaw } from 'vue-router';

export const patientRoutes: RouteRecordRaw[] = [
  // WEBログイン・登録（LIFF不要、独立レイアウト）
  {
    path: '/patient/web-login',
    name: 'PatientWebLogin',
    component: () => import('@/components/views/patient/PatientWebLogin.vue'),
    meta: { title: '会員ログイン' },
  },
  {
    path: '/patient/web-register',
    name: 'PatientWebRegister',
    component: () => import('@/components/views/patient/PatientWebRegister.vue'),
    meta: { title: '会員登録' },
  },
  {
    path: '/patient',
    component: () => import('@/components/layouts/patient/PatientLayout.vue'),
    children: [
      {
        path: '',
        redirect: { name: 'PatientEstimateList' },
      },
      {
        // 旧 /patient/top（リファクタコミット 8287040 で削除）の復活。
        // LIFFリッチメニュー等のURLが /patient/top のままになっているため受け、
        // LIFF init → loginPatient → 友だちcheck → 適切な画面へ navigate するゲートウェイ。
        path: 'top',
        name: 'PatientTop',
        component: () => import('@/components/views/patient/PatientTop.vue'),
        meta: { title: 'TOP' },
      },
      {
        path: 'register',
        name: 'PatientRegister',
        component: () => import('@/components/views/patient/PatientRegister.vue'),
        meta: { title: '会員情報入力' },
      },
      {
        path: 'friend-add',
        name: 'PatientFriendAdd',
        component: () => import('@/components/views/patient/FriendAddPrompt.vue'),
        meta: { title: '友だち追加のお願い' },
      },
      {
        path: 'me',
        name: 'PatientProfile',
        component: () => import('@/components/views/patient/PatientProfile.vue'),
        meta: { title: 'マイページ' },
      },
      {
        path: 'estimates',
        name: 'PatientEstimateList',
        component: () => import('@/components/views/patient/EstimateList.vue'),
        meta: { title: '見積一覧' },
      },
      {
        path: 'estimates/:id',
        name: 'PatientEstimateDetail',
        component: () => import('@/components/views/patient/EstimateDetail.vue'),
        meta: { title: '見積詳細' },
        props: true,
      },
      {
        path: 'contracts',
        name: 'PatientContractList',
        component: () => import('@/components/views/patient/ContractList.vue'),
        meta: { title: '契約一覧' },
      },
      {
        path: 'contracts/:id',
        name: 'PatientContractDetail',
        component: () => import('@/components/views/patient/ContractDetail.vue'),
        meta: { title: '契約詳細' },
        props: true,
      },
      {
        path: 'contracts/:id/sign',
        name: 'ContractSigning',
        component: () => import('@/components/views/patient/ContractSigning.vue'),
        meta: { title: '契約書確認・署名' },
        props: true,
      },
      {
        path: 'contracts/:id/consent-sign',
        name: 'ConsentSigning',
        component: () => import('@/components/views/patient/ConsentSigning.vue'),
        meta: { title: '同意書確認・署名' },
        props: true,
      },
      {
        path: 'complete',
        name: 'ContractComplete',
        component: () => import('@/components/views/patient/ContractComplete.vue'),
        meta: { title: '契約完了' },
      },
    ],
  },
];
